"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Grid = _interopRequireDefault(require("@mui/material/Grid"));

var _Paper = _interopRequireDefault(require("@mui/material/Paper"));

var _Typography = _interopRequireDefault(require("@mui/material/Typography"));

var _Button = _interopRequireDefault(require("@mui/material/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PDFViewer = function PDFViewer(_ref) {
  var pdf = _ref.pdf,
      height = _ref.height,
      filename = _ref.filename,
      documentDescription = _ref.documentDescription;
  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    alignContent: "center"
  }, /*#__PURE__*/_react.default.createElement("object", {
    width: "100%",
    height: height,
    id: "plugin",
    type: "application/pdf",
    data: pdf,
    download: filename
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    justifyContent: "center",
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Paper.default, {
    elevation: 3,
    style: {
      padding: "5%",
      alignContent: "center",
      margin: "5%"
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, null, "Your browser does not support viewing embedded PDF documents. Please ensure you have a PDF reader available to view the document after downloading."), /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "outlined",
    href: pdf,
    download: filename
  }, "Download the ", documentDescription))))));
};

var _default = PDFViewer;
exports.default = _default;